const incompleteDateTimeFormatPattern =
  /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/;

/**
 * ISO string を受け取って yyyy年mm月dd日 hh時mm分 の形式にフォーマットする
 * 月日は1桁の場合0埋めしない
 * @example '2023-03-20T10:10:00.000+09:00' => '2023年3月20日 10時10分'
 */
export const formatIsoStringToJp = (dateString: string) => {
  const isoString = (() => {
    if (incompleteDateTimeFormatPattern.test(dateString)) {
      return dateString.replaceAll('-', '/');
    }

    return dateString;
  })();

  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1);
  const day = String(date.getDate());
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');

  return `${year}年${month}月${day}日 ${hour}時${minute}分`;
};
